define('commons/floating-panel',['jquery'], function($) {

    var FloatingPanel = function(options) {
        this.settings = {
            title: "",
            content: null, // id, node or html
            contentUrl: null,
            customClassSuffix: null,
            zIndex: 100,
            fxFadeDuration: 400, //ms
            fxSizeDuration: 700, //ms
            maxWidth: "70%", // % of window or px
            maxHeight: "60%", // % of window or px
            onSuccess: function(data) {
            },
            closeOnEscape: true,
        };
        $.extend(this.settings, options);
    
        var sizeFn = function(value) {
            return {
                percent: value.indexOf('%') !== -1,
                value: parseInt(value)
            };
        };
        
        // Private variables
        this._displayed = false; // Is the panel is displayed?
        this._maxSize = { // Size limits
            width: sizeFn(this.settings.maxWidth),
            height: sizeFn(this.settings.maxHeight)
        };
        this._minSize = {"min-width": 100, "min-height": 100};
        
        // Create the floating card containers
        this.$container = $("<div class='floating-panel" + (this.settings.customClassSuffix ? " floating-panel-" + this.settings.customClassSuffix : "") + "'></div>").css({
            "display": "none",
            "position": "fixed",
            "top": "50%",
            "left": "50%",
            "z-index": this.settings.zIndex + 1
        }).appendTo(document.body);
        this.$title = $("<div class='floating-panel-title'></div>").text(this.settings.title).css({
            "text-overflow": "ellipsis",
            "white-space": "nowrap",
            "overflow": "hidden"
        }).appendTo(this.$container);
        this.$content = $("<div class='floating-panel-content'></div>").css($.extend({"overflow": "auto"}, this._minSize)).appendTo(this.$container);
        if(this.settings.contentNode) {
            this.$content.append($(this.settings.content));
        }
        
        // Create the background overlay
        this.$overlay = $("<div class='floating-panel-overlay" + (this.settings.customClassSuffix ? " floating-panel-overlay-" + this.settings.customClassSuffix : "") + "'></div>");
        this.$overlay.css({
            "display": "none",
            "position": "fixed",
            "top": "0px",
            "left": "0px",
            "width": "100%",
            "height": "100%",
            "z-index": this.settings.zIndex
        }).appendTo(document.body).click($.proxy(function() {
            if(this.settings.closeOnEscape) {
                this.hide();
            }
        }, this));
        
        this.$w = $(window).resize($.proxy(function() {
            if(this._displayed) {
                this._setMaxSize();
            }
        }, this));
        this._setMaxSize();
    };
    
    /**
     * Private functions
     */
    
    /**
     * @param side: side to check "height" or "width"
     * @returns a converted pixel number
     */
    FloatingPanel.prototype._getMaxSizeInPixel = function(side) {
        if(this._maxSize[side].percent) {
            return Math.round(this.$w[side]() * this._maxSize[side].value / 100);
        }
        return this._maxSize[side].value;
    };
    
    FloatingPanel.prototype._getMaxSize = function() {
        return {
            "max-height": this._getMaxSizeInPixel("height"),
            "max-width": this._getMaxSizeInPixel("width")
        };
    };
    
    FloatingPanel.prototype._setMaxSize = function() {
        var mSize = this._getMaxSize();
        this.$content.css(mSize);
        this.$title.css(mSize);
    };
    
    /**
     * Public functions
     */
    
    FloatingPanel.prototype.setTitle = function(title) {
        this.$title.text(title);
    };
    
    FloatingPanel.prototype.setContent = function(content) {
        if(this._displayed) {
            var h = this.$content.height();
            var w = this.$content.width();
            this.$content.empty().css({
                "overflow": "hidden",
                "min-height": h,
                "min-width": w,
                "max-height": h,
                "max-width": w
            }).append($(content)).scrollTop(0).animate($.extend(this._getMaxSize(), this._minSize), {
                "duration": this.settings.fxSizeDuration,
                "complete": $.proxy(function() {
                    this.$content.css({"overflow": "auto"});
                }, this)
            });

            this.settings.onSuccess(content);
        } else {
            this.$content.empty().append($(content));
        }
    };
    
    FloatingPanel.prototype.loadContent = function(url) {
        this.$content.empty().addClass("loading");
        $.ajax({
            url: url,
            dataType: "html",
            context: this
        }).done(function(data, textStatus, jqXHR) {
            this.$content.removeClass("loading");
            this.setContent(data);
        });
    };
    
    FloatingPanel.prototype.show = function(url) {
        this._displayed = true;
        this.$container.fadeIn(this.settings.fxFadeDuration);
        this.$overlay.fadeIn(this.settings.fxFadeDuration);
        url = url || this.settings.contentUrl;
        if(url) {
            this.loadContent(url);
        }
    };
    
    FloatingPanel.prototype.hide = function() {
        this._displayed = false;
        this.$container.fadeOut(this.settings.fxFadeDuration);
        this.$overlay.fadeOut(this.settings.fxFadeDuration);
    };
    
    return FloatingPanel;
    
});
